import * as React from 'react';

export type ChangeHandler<V> = (value: V) => void; // tslint:disable-line

export type PersistProps<V> = {
    defaultValue?: string;
    value?: string | null;
    onChange?: ChangeHandler<V>;
};

export type Options = {
    storage: Storage;
    key: string;
    valueName?: string;
    onChangeName?: string;
    defaultValue?: string | null;
};

//
// persist is a higher-order component that supplies a saved value to a wrapped control and
// also watches the onChange event from the wrapped control to save new values.
//
export const persist =
    ({ storage, key, valueName = 'value', onChangeName = 'onChange', defaultValue = null }: Options) =>
        <T extends PersistProps<V>, V>(Target: React.ComponentType<T>) =>
            class Persist extends React.Component<T, {}> { // TODO: type subtraction from T... e.g. "T - PersistProps" or "rest(T, keyof PersistProps)"
                static displayName = `persist(${Target.displayName || Target.name || '?'})`;

                initialValue: string | null;

                constructor(props: T) {
                    super(props);
                    this.initialValue = storage.getItem(key);
                    if (this.initialValue === null && typeof props.defaultValue === 'string') {
                        this.initialValue = props.defaultValue;
                    }
                    if (this.initialValue === null && typeof defaultValue === 'string') {
                        this.initialValue = defaultValue;
                    }
                }

                onChange = (value: V) => {
                    storage.setItem(key, `${value}`);

                    // Pass on to the change handler in the props (if it was defined)
                    const onChange = this.props[onChangeName] as ChangeHandler<V>;
                    if (onChange) {
                        onChange(value);
                    }
                }

                render() {
                    return (
                        <Target
                            { ...this.props }
                            { ...{
                                [valueName]: this.initialValue,
                                [onChangeName]: this.onChange,
                            } }
                        />
                    );
                }
            }
;



// WEBPACK FOOTER //
// ./src/ui/shared/persist.tsx